import { useSyncExternalStore } from "react";

import { areaLib } from "@/utils/areaLib";

/**
 * React 地区库订阅钩子：地区 JSON 加载完成后触发页面重新读取地址名称。
 * 兼容仅 mock 了 getFullAreaName 的旧测试替身，缺少订阅能力时保持静态读取。
 */
export function useAreaLib() {
    useSyncExternalStore(
        listener => areaLib.subscribe?.(listener) ?? (() => undefined),
        () => areaLib.version ?? 0,
        () => 0
    );
    return areaLib;
}
